// Auto-generate TOC
const content = document.querySelector('#article-content');
const toc = document.querySelector('#toc ul');
const headers = content.querySelectorAll('h2, h3');


headers.forEach((h, i) => {
const id = 'section-' + i;
h.id = id;
const li = document.createElement('li');
li.innerHTML = `<a href="#${id}">${h.textContent}</a>`;
toc.appendChild(li);
});
// Article add to cart
document.querySelectorAll('.cs-atc-btn').forEach(button => {
  button.addEventListener('click', function() {
    const productId = this.getAttribute('data-product-id');
    const quantity = 1;  

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: productId, 
            quantity: quantity,
          }
        ]
      })
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = "/checkout?utm_source=article_page&utm_medium=side_cta";  // 跳转到结账页面
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  });
});

/*blog article menu */
  const blMenuIcon = document.getElementById('bl_menu-icon');
  const blNavList = document.getElementById('bl_nav-list');

  blMenuIcon.addEventListener('click', () => {
      blMenuIcon.classList.toggle('active');
      blNavList.classList.toggle('active');

  });